import React, { ButtonHTMLAttributes } from 'react';
import { FaRegCheckCircle, FaRegCircle } from 'react-icons/fa';
import { MdOutlineCancel } from 'react-icons/md';

import { Container } from './styles';

interface IValidateAltProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  status: string;
}

const ValidateAlt: React.FC<IValidateAltProps> = ({ status, ...rest }) => {
  return (
    <Container {...rest} type="button" status={status}>
      {status === 'success'
        ? 'Validado'
        : status === 'error'
        ? 'Inválido'
        : 'Validar'}

      {status === 'success' ? (
        <FaRegCheckCircle size={16} />
      ) : status === 'error' ? (
        <MdOutlineCancel size={16} />
      ) : (
        <FaRegCircle size={16} />
      )}
    </Container>
  );
};

export default ValidateAlt;
